import { ApiErrorMessageWithTrans } from '@components/Error/ApiErrorMessageWithTrans';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import type { FacilityTransferItemPublicRecord } from '@navio/nsdk';
import type { NoddiAsyncError } from 'noddi-types';
import { NoddiButton, NoddiDialog, NoddiTextArea } from 'noddi-ui-web';
import { useState } from 'react';

interface Props {
  item: FacilityTransferItemPublicRecord;
  initialComment: string;
  isSaving: boolean;
  error: NoddiAsyncError | null;
  onSave: (comment: string) => void;
  onClose: () => void;
}

export const IssueDialog = ({ item, initialComment, isSaving, error, onSave, onClose }: Props) => {
  const [comment, setComment] = useState(initialComment);
  const trimmed = comment.trim();
  const label = item.licensePlate ?? item.storageObjectGroupIdentifier;
  return (
    <NoddiDialog
      title={t`Report issue: ${label}`}
      open
      onClose={onClose}
      footer={
        <div className='flex flex-col gap-4'>
          {error && <ApiErrorMessageWithTrans error={error} />}
          <div className='flex flex-wrap justify-end gap-2'>
            <NoddiButton variant='outline' onClick={onClose}>
              <Trans>Cancel</Trans>
            </NoddiButton>
            <NoddiButton
              variant='destructive'
              loading={isSaving}
              disabled={trimmed === '' || isSaving}
              onClick={() => onSave(trimmed)}
            >
              <Trans>Save issue</Trans>
            </NoddiButton>
          </div>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <p className='text-sm text-muted-foreground'>
          <Trans>Tell us what's wrong with this wheel set so the destination team can prepare.</Trans>
        </p>
        <NoddiTextArea
          value={comment}
          placeholder={t`Describe the issue (e.g. cant find tires, tires worn out / damaged, etc.)`}
          onChange={(e) => setComment(e.target.value)}
        />
      </div>
    </NoddiDialog>
  );
};
